import React from "react";
import { StyleSheet, View } from "react-native";
import { topNavigationColors, topNavigationProps } from "styles/top-navigation";
import { DrawerHamburgerStyles } from 'styles/components/atoms/DrawerHamburger'
import ThemedPressable from 'components/atoms/ThemedPressable'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'


const DrawerHamburger = ({ navigation }) => {
	
	const iconStyle = [
		topNavigationProps.iconLarge,
		staticStyles.iconStyleFontSize20WidthAuto
	]
	
	return (
		<ThemedPressable
			onPress={ navigation.openDrawer }>
			
			<View
				style={ DrawerHamburgerStyles.drawer }>
				
				<Icon
					icon={ IconSystemConstants.HAMBURGER_DRAWER }
					style={ iconStyle }
					color={ topNavigationColors.light }
				/>
			</View>
		</ThemedPressable>
	);
}

const staticStyles = StyleSheet.create({
	iconStyleFontSize20WidthAuto: {
		fontSize: 20,
		width: 'auto',
		height: 'auto',
	},
});

export default DrawerHamburger
